<div fxLayout="column" style="width:300px;">
  <div fxLayout="row" fxFlex="grow">
    Συμπληρώστε τον τίτλο για να αποθηκεύσετε την αναζήτησή σας
  </div>



  <div fxLayout="row" fxFlex="grow" fxLayoutAlign="center center center">
    <mat-form-field>
      <label>
        <input matInput [(ngModel)]="queryTitle">
      </label>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center center" fxLayoutGap="10px">
    <button mat-raised-button (click)="cancel()">Ακύρωση</button>
    <button mat-raised-button (click)="save()" color="primary">Αποθήκευση</button>
  </div>
</div>
